import axios from "axios";
import appconst from "./appconst";
import Vue from "vue";

const ajax = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  withCredentials: true,
  timeout: 30000
});

ajax.interceptors.request.use(
  function(config) {
    if (!!window.abp.auth.getToken()) {
      config.headers.common["Authorization"] = "Bearer " + window.abp.auth.getToken();
    }
    config.headers.common[".AspNetCore.Culture"] = window.abp.utils.getCookieValue("Abp.Localization.CultureName");
    config.headers.common["Abp.TenantId"] = window.abp.multiTenancy.getTenantIdCookie();
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

let vm = new Vue({});
ajax.interceptors.response.use(
  respon => {
    return respon;
  },
  error => {
    if (!!error.response && !!error.response.data.error && !!error.response.data.error.message && error.response.data.error.details) {
      if (error.response.data.error.code === 10001 || error.response.data.error.code === 10002 || error.response.data.error.code === 10003) {
      } else {
        vm.$Modal.error({ title: error.response.data.error.message, content: error.response.data.error.details });
      }
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
      if (error.response.status === 401) {
        window.abp.auth.clearToken();
        window.location.href = "/";
      } else if (error.response.data.error && (error.response.data.error.code === 4031 || error.response.data.error.code === 4032)) {
      } else {
        vm.$Modal.error({ title: "Oops!", content: error.response.data.error.message });
      }
    } else if (!error.response) {
      vm.$Modal.error(window.abp.localization.localize("UnknownError"));
    }
    setTimeout(() => {
      vm.$Message.destroy();
    }, 1000);
    return Promise.reject(error);
  }
);
export default ajax;
